import { render, staticRenderFns } from "./logo-img.vue?vue&type=template&id=6b2b761d&scoped=true&"
import script from "./logo-img.vue?vue&type=script&lang=js&"
export * from "./logo-img.vue?vue&type=script&lang=js&"
import style0 from "./logo-img.vue?vue&type=style&index=0&id=6b2b761d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b761d",
  null
  
)

export default component.exports